import { render } from "./Recover.vue?vue&type=template&id=094430f1&lang=pug"
import script from "./Recover.vue?vue&type=script&lang=js"
export * from "./Recover.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__